import dayjs from 'helpers/dayjs';
import BaseItemInterface from 'interfaces/base-item.interface';
import { LinkTarget } from 'atomic/link/link-target.enum';

interface ExtendedBaseItemInterface extends BaseItemInterface {
    isRanking?: boolean;
}

export const CUSTOM_TOP_DATA: ExtendedBaseItemInterface[] = [
    {
        url: 'https://www.skapiec.pl/radzi',
        image: '',
        target: LinkTarget.BLANK,
        title: 'Skąpiec radzi',
        isRanking: false
    },
    {
        url: 'https://www.skapiec.pl/radzi/poradniki',
        image: '',
        target: LinkTarget.BLANK,
        title: 'Poradniki',
        isRanking: false
    },
    {
        url: 'https://news.skapiec.pl/',
        image: '',
        target: LinkTarget.BLANK,
        title: 'News',
        isRanking: false
    },
    {
        url: 'https://www.skapiec.pl/cat/2744-smartwatch/ranking.html',
        image: '',
        target: LinkTarget.BLANK,
        title: `Ranking Smartwatchy ${dayjs().year()}`,
        isRanking: true
    }
];
